<template>
  <div class="order-detail-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.order_history') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.order_history') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="order"/>
      </div>
      <div class="page-right">
        <div class="order-info">
          <div class="left hide-on-pad">{{ $t('order_history.buy_date') }}: {{ detail.orderdate }}</div>
          <div class="center">{{ $t('order_history.no') }}: {{ no }}</div>
          <div class="right">{{ $t('order_history.status') }}: {{ getProcessText }}</div>
        </div>

        <div class="table-list">
          <div class="table-header hide-on-pad-flex">
            <div class="td index">{{ $t('order_history.no') }}</div>
            <div class="td img withoutPT"></div>
            <div class="td detail">{{ $t('order_history.product_detail') }}</div>
            <div class="td qty">{{ $t('order_history.qty') }}</div>
            <div class="td price">{{ $t('order_history.price2') }}</div>
          </div>
          <div class="table-body" v-if="JSON.stringify(detail)!='{}'">
            <div class="tr hide-on-pad-flex" v-for="(item,index) in detail.orderdetail" :key="index+'_'+item.supplyNo+'_pc'">
              <div class="td index box-center">{{ index+1 }}</div>
              <div class="td img"><img :src="item.products_photo" alt="product-img"></div>
              <div class="td detail">
                <p>{{ $t('order_history.product_name') }}: {{ item.product_name }}</p>
                <p>{{ item.color }}, {{ item.standard+item.size }}</p>
                <p class="p-no">{{ $t('order_history.product_no') }}: {{ item.product_no }}</p>
              </div>
              <div class="td qty box-center">{{ item.qty }}</div>
              <div class="td price box-center">{{ item.price | formatPrice}}</div>
            </div>
            <div class="tr show-on-pad-flex" v-for="(item,index) in detail.orderdetail" :key="index+'_'+item.supplyNo+'_mob'">
              <div class="td img"><img :src="item.products_photo" alt="product-img"></div>
               <div class="td detail">
                <div>
                  <p class="p-no">{{ $t('order_history.product_no') }}: {{ item.product_no }}</p>
                  <p class="name">{{ item.product_name }}</p>
                </div>
                <div>
                  <p class="color">{{ $t('order_history.product_color') }}: {{ item.color }}</p>
                  <p>{{ $t('order_history.product_size') }}: {{ item.standard+item.size }}</p>
                  <p>{{ $t('order_history.product_qty') }}: {{ item.oqty }}</p>
                </div>
                <p class="price">{{ item.price | formatPrice}}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card-list shipping-info">
          <div class="card">
            <div class="card-title">1.{{ $t('order_history.ship_way') }}</div>
            <div class="card-body">
              <div class="group-info-item flex-x">
                <div class="item-title">{{ $t('order_history.ship_date') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-x">{{ detail.toteDate }}</div>
                </div>
              </div>
              <div class="group-info-item flex-x">
                <div class="item-title">{{ $t('order_history.ship_time') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-x">{{ formatTotalTime(detail.toteTime) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-title">{{ $t('order_history.order_total') }}</div>
            <div class="card-body">
              <p class="cart-info">{{ $t('order_history.count') }}<span>{{ detail.sumprice | formatPrice }}</span></p>
              <p class="cart-info">{{ $t('order_history.ship') }}<span>{{ detail.toteFee | formatPrice }}</span></p>
              <p class="cart-info">{{ $t('order_history.coupon') }}<span>{{ getDiscountText }}</span></p>
              <p class="cart-info total">{{ $t('order_history.total') }}<span>{{  detail.totalAmt | formatPrice }}</span></p>
            </div>
          </div>
        </div>

        <div class="card-list receive-info">
          <div class="card">
            <div class="card-title">2.{{ $t('order_history.recipient') }}</div>
            <div class="card-body">
              <div class="group-info-item flex-x">
                <div class="item-title has-black-radio">{{ $t('order_history.recipient_detail') }}: </div>
              </div>
              <div class="group-info-item flex-s">
                <div class="item-title">{{ $t('order_history.name') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-x">{{ detail.name }}</div>
                </div>
              </div>
              <div class="group-info-item flex-s">
                <div class="item-title">{{ $t('order_history.phone') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-x">{{ detail.telphone }}</div>
                </div>
              </div>
              <div class="group-info-item flex-s">
                <div class="item-title">{{ $t('order_history.mobile') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-x">{{ detail.mobile }}</div>
                </div>
              </div>
              <div class="group-info-item mt-10 flex-x">
                <div class="item-title">{{ $t('order_history.addr') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-s">{{ formatEmpty(detail.province) }}</div>
                  <div class="read-only-input flex-s">{{ formatEmpty(detail.city) }}</div>
                  <div class="read-only-input flex-s">{{ formatEmpty(detail.area) }}</div>
                  <div class="read-only-input flex-x">{{ detail.zip }}{{ detail.address }}</div>
                </div>
              </div>
              <div class="group-info-item mt-10 flex-x">
                <div class="item-title">{{ $t('order_history.remark') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-x min-h-8">{{ formatEmpty(detail.note) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-list payment-info">
          <div class="card">
            <div class="card-title">3.{{ $t('order_history.pay_type') }}</div>
            <div class="card-body">
              <div class="group-info-item flex-x">
                <div class="item-title">{{ $t('order_history.pay_type') }}: </div>
                <div class="item-content">
                  <div class="read-only-input flex-s">{{ getPayWayText }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btn btn-orange btn-back" @click="handlePageBack">{{ $t('btns.back') }}</div>

      </div>
    </div>
  </div>
</template>

<script>
import mackimg from './images/JET_0049@2x.png';
import userSideMenu from '../../components/UserSideMenu'
import { getOrderDetail } from '../../api/index.js'
import chinacode from '../EditInfo//mock/chinacode.json';

  export default {
    name: 'order-detail',
    data() {
      return {
        mackimg,
        no: '',
        detail: {}
      }
    },
    components: {
      userSideMenu
    },
    computed: {
      getProcessText() {
        if(this.detail.process) {
          switch (this.detail.process) {
            case 1:
              return this.$t('format.process1');
              break;
            case 2:
              return this.$t('format.process2');
              break;
            case 3:
              return this.$t('format.process3');
              break;
            case 4:
              return this.$t('format.process4');
              break;
            case 5:
              return this.$t('format.process5');
              break;
            default:
              return this.$t('format.no_process');
              break;
          }
        }else{
          return this.$t('format.no_supply');
        }
      },
      getPayWayText() {
        if(this.detail.payway_ind) {
          switch (this.detail.payway_ind) {
            case 1:
              return this.$t('format.pay_type1');
              break;
            case 2:
              return this.$t('format.pay_type2');
              break;
            default:
              return this.$t('format.no_pay_type');
              break;
          }
        }else{
          return this.$t('format.no_supply');
        }
      },
      getDiscountText() {
        if(this.detail.discount_batch_amt && this.detail.discount_batch_percent) {
          const priceSplit = String(this.detail.discount_batch_amt).split('.');
          const priceFloat = priceSplit[1] || '0';
          const priceArr = priceSplit[0].split('');
          let price = '';
          priceArr.forEach((item, index) => {
              if (index >= 3 && index % 3 == 0) {
                  price = priceArr[priceArr.length - index - 1] + ',' + price;
              } else {
                  price = priceArr[priceArr.length - index - 1] + price;
              }
          })
          return `-${this.detail.discount_batch_percent}%($${price}.${priceFloat})`;
        }else{
          return this.$t('format.empty');
        }
      }
    },
    created() {
      const { no } = this.$route.query;
      console.log('no',no);
      this.no = no;
      this.getDetail();
    },
    filters: {
      formatPrice(value) {
        let priceText = 0;
        if(value && value!='undefined') priceText = value;
        const priceArr = String(priceText).split('');
        let price = '';
        priceArr.forEach((item, index) => {
            if (index >= 3 && index % 3 == 0) {
                price = priceArr[priceArr.length - index - 1] + ',' + price;
            } else {
                price = priceArr[priceArr.length - index - 1] + price;
            }
        })
        return '$'+price;
      }
    },
    methods: {
      async getDetail() {
        const data = await getOrderDetail({ no: this.no })
        console.log('data',data);
        // 把地址的代码换成文字

        const provinceObj = chinacode.filter(item => item.code==data.province)[0] || '' ;
        const cityObj = provinceObj ? provinceObj.children.filter(item => item.code==data.city)[0] || '' : '';
        const areaObj = cityObj ? cityObj.children.filter(item => item.code==data.area)[0] || '' : '';

        data.province = provinceObj.name || this.$t('format.empty');
        data.city = cityObj.name || this.$t('format.empty');
        data.area = areaObj.name || this.$t('format.empty');

        this.detail = data;
      },
      handlePageBack() {
        this.$router.push({ name: 'order' });
      },
      formatEmpty(value) {
        if(!value) return this.$t('format.empty');
        return value;
      },
      formatTotalTime(value) {
        if(value) {
          switch (value) {
            case 1:
              return this.$t('order_history.morning');
              break;
            case 2:
              return this.$t('order_history.afternoon');
              break;
            case 3:
              return this.$t('order_history.evening');
              break;
            default:
              return this.$t('order_history.unknow_time');
              break;
          }
        }else{
          return this.$t('format.empty');
        }
      },
    }
  }
</script>

<style lang="less" scoped>
.order-detail-page {
  .order-info {
    background: #F0F0F0;
    padding: 30px 15px;
    display: flex;
    margin-bottom: 30px;
    .left {
      flex: 1;
    }
    .center {
      flex: 1;
      text-align: center;
    }
    .right {
      flex: 1;
      text-align: right;
    }
  }
  .table-list {
    text-align: center;
    margin-bottom: 30px;
    .table-header {
      background: #F0F0F0;
      padding: 15px 15px;
      display: flex;
      margin-bottom: 10px;
      .index {
        text-align: left;
      }
    }
    .table-body {
      .tr {
        display: flex;
        border-bottom: 1px solid #E6E6E6;
        padding: 20px 0;
      }
      .detail {
        text-align: left;
      }
    }
    .index {
      flex: 0 0 13%;
    }
    .img {
      flex: 0 0 20%;
      margin: 0 15px;
      position: relative;
      padding-top: calc(20%/240*300);
      &.withoutPT {
        padding-top: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
      }
    }
    .detail {
      flex: 0 0 30%;
      position: relative;
      p {
        margin-bottom: 10px;
      }
      .p-no {
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .qty {
      flex: 0 0 18%;
    }
    .price {
      flex: 0 0 19%;
    }
  }
  .card-list {
    display: flex;
  }
  .card {
    padding: 15px;
    border: 1px solid #E6E6E6;
    margin-left: 15px;
    flex: 1;
    margin-bottom: 30px;
    &:nth-child(1) {
      margin-left: 0;
    }
    .card-title {
      font-weight: 400;
      color: black;
      padding-bottom: 15px;
      border-bottom: 1px solid #E6E6E6;
      font-size: 1.4rem;
    }
    .card-body {
      padding-top: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .group-info-item {
        margin-bottom: 15px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        &.flex-s {
          flex: 0 0 calc(33% - 20px);
        }
        &.flex-x {
          flex: 0 0 100%;
        }
        .item-title {
          margin-bottom: 15px;
          font-weight: 300;
          &.has-black-radio {
            padding-left: 26px;
            position: relative;
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0px;
              height: 6px;
              width: 6px;
              border: 6px solid black;
              border-radius: 50%;
            }
            @media (max-width: 992px) {
              &::before {
                height: 6px;
                width: 6px;
                background: white;
                border: 5px solid #707070;
                border-radius: 50%;
              }
            }
          }
        }
        .item-content {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .flex-s {
            margin-bottom: 15px;
            flex: 0 0 calc(33% - 20px);
          }
          .flex-x {
            margin-bottom: 15px;
            flex: 0 0 100%;
          }
        }
        .read-only-input {
          border: 1px solid #707070;
          padding: 5px 15px;
          min-height: calc(1rem + 10px); // 10px是padding的上下5px
        }
      }
      .cart-info {
        position: relative;
        margin-bottom: 20px;
        flex: 0 0 100%;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        span {
          position: absolute;
          right: 0;
        }
        &.total {
          font-size: 1.4rem;
          font-weight: 400;
          color: black;
          border-top: 1px solid #E6E6E6;
          padding-top: 20px;
          span {
            color: #FF5214;
          }
        }
      }
    }
  }
  .btn-back {
    max-width: 150px;
    margin: auto;
    margin-bottom: 30px;
    @media (max-width: 992px) {
      margin-top: -10px;
    }
  }
  @media (max-width: 992px) {
    .page-title {
      margin-bottom: 0;
    }
    .page-container {
      padding-top: 0;
    }
    .order-info {
      padding: 5px 15px;
      margin: 0px -15px 0px -15px;
      .center {
        text-align: left;
      }
    }
    .table-list {
      .img {
        flex: 0 0 30%;
        padding: 0;
        margin: 0;
        border-radius: 10px;
        overflow: hidden;
        padding-top: calc(30%/240*300);
        &.withoutPT {
          padding-top: 0;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .detail {
        flex: 0 0 70%;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        p {
          margin: 0;
        }
        .p-no {
          position: relative;
          margin-bottom: 5px;
        }
        .name {
          font-size: 1.4rem;
          font-weight: 400;
        }
        .color {
          margin-bottom: 5px;
        }
        .price {
          color: #FF5214;
          line-height: 1rem;
          flex: unset;
          font-size: 1.4rem;
        }
      }
    }
    .card-list {
      flex-direction: column-reverse;
    }
    .card {
      margin-left: 0;
      background: #F7F8FA;
      margin-bottom: 15px;
      border: unset;
      .card-title {
        font-weight: 300;
        padding-bottom: 15px;
        border-bottom: 1px solid #E6E6E6;
        text-align: center;
        font-size: 1rem;
      }
      .card-body {
        .cart-info.total {
          font-weight: 300;
          font-size: 1rem;
          span {
            color: black;
          }
        }
        .group-info-item {
          .min-h-8 {
            min-height: calc(8rem + 10px);
          }
          &.flex-s {
            flex: 0 0 100%;
          }
          .read-only-input {
            border: 1px solid #E6E6E6;
          }
        }
      }
    }
    .payment-info {
      .card-body {
        .group-info-item {
          .item-content .flex-s {
            flex: 0 0 100%;
          }
        }
      }
    }
  }
}
</style>